import { useMemo } from 'react';
import { Edge } from 'reactflow';
import {
  CanvasElementState,
  CanvasZIndex,
} from '@components/MainStage/canvasStates';
import useHover from '@components/MainStage/hover.store';

const useEdgeLayers = (edges: Edge[]): Edge[] => {
  const hoveredEdgeId = useHover((state) => state.hoveredEdgeId);

  return useMemo(
    () =>
      edges.map((edge) => {
        if (edge.data?.canvas?.state === CanvasElementState.Disabled) {
          return { ...edge, zIndex: CanvasZIndex.Disabled };
        }

        if (edge.id === hoveredEdgeId || edge.selected) {
          return { ...edge, zIndex: CanvasZIndex.FocusedLine };
        }

        return { ...edge, zIndex: CanvasZIndex.Line };
      }),
    [edges, hoveredEdgeId],
  );
};

export default useEdgeLayers;
